'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchPrV2AiAttribution } from './fetch-pr-v2';
import { PR_V2_STANDARD_STALE_TIME_MS } from './query-config';
import { prV2AiAttributionQueryKey } from './query-keys';
import { useDeferredQueryEnabled } from '@/hooks/use-deferred-query-enabled';
export function usePrV2AiAttribution(owner, repo, number, headSha, options) {
  const $ = _c(13);
  const isPastStartupWindow = useDeferredQueryEnabled();
  let t0;
  if ($[0] !== headSha || $[1] !== number || $[2] !== owner || $[3] !== repo) {
    t0 = prV2AiAttributionQueryKey(owner, repo, number, headSha);
    $[0] = headSha;
    $[1] = number;
    $[2] = owner;
    $[3] = repo;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== number || $[6] !== owner || $[7] !== repo) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchPrV2AiAttribution(owner, repo, number, signal);
    };
    $[5] = number;
    $[6] = owner;
    $[7] = repo;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = Boolean(owner && repo && number) && (options?.enabled ?? true) && isPastStartupWindow;
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: PR_V2_STANDARD_STALE_TIME_MS,
      refetchOnWindowFocus: false
    };
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return useQuery(t3);
}